import i18n from 'l10n';
import GenericView from 'js/views/generic.view';
import Template from 'js/templates/group.report.tile.hbs';
import {on, tagName, template} from "../adapters/backbone-decorators";

require('interfaceAdapter');
require('metroHelpers');

@tagName('span')
@template(Template)
class GroupReportTileView extends GenericView {
    constructor(options) {
        super(options);
        this.CCview = options.CCview;
        this.model.bind("change", this.render, this);
    }

    render() {
        super.render();
        this.$el.find('.tile').droppable({
            drop: (event, ui) => {
                var el = ui.draggable;
                console.log("gg");
                $.ajaxDefaultQ({
                    url: `${this.model.url()}/items/${el.data("id")}`,
                    type: 'PUT',
                    dataType: 'json'
                }).done(data => {
                    if (data.outcome === "OK") {
                        this.model.fetch();
                    } else {
                        $.Notify.error(i18n.t("groups.contactingroup") + '.');
                    }
                }).fail(data => {
                    $.Notify.error(i18n.t("groups.putfailed") + ' = ' + (data.status ? data.status : ""));
                });
            }
        });

        this.$('[data-i18n]').i18n();
    }

    @on('click')
    viewGroup() {
        var theId = this.model.get(this.model.idAttribute);
        document.location.href = "/CampaignCloud/cloudui/home/Contacts.htm#Group/" + theId;
    }
}

export default GroupReportTileView;
